import React from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { featureConfigs, features, planConfigs, planFeatures, plans } from 'pages/Landings/sections/Pricing/constants';
import { Period } from 'pages/Landings/sections/Pricing/types';

import useStyles from './styles';

import CheckIcon from '../../assets/check.svg';
import MissedIcon from '../../assets/missed.svg';
import Feature from '../../components/Feature';
import PlanSummary from '../../components/PlanSummary';

interface Props {
    period: Period;
    className?: string;
}

const Desktop: React.FC<Props> = ({ period, className }) => {
    const { classes, cx } = useStyles();

    return (
        <TableContainer className={cx(classes.root, className)}>
            <Table className={classes.table}>
                <colgroup>
                    <col />
                    {plans.map((plan) => (
                        <col key={plan} width={225} />
                    ))}
                </colgroup>
                <TableHead>
                    <TableRow>
                        <TableCell data-role="spacer" />
                        {plans.map((plan) => (
                            <TableCell key={plan}>
                                <PlanSummary plan={plan} period={period} />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>{'API Credits per month'}</TableCell>
                        {plans.map((plan) => (
                            <TableCell key={plan}>{planConfigs[plan].credits}</TableCell>
                        ))}
                    </TableRow>
                    {features.map((feature) => (
                        <TableRow key={feature}>
                            <TableCell>
                                <Feature
                                    title={featureConfigs[feature].title}
                                    href={featureConfigs[feature].href}
                                    tooltip={featureConfigs[feature].tooltip}
                                />
                            </TableCell>
                            {plans.map((plan) => (
                                <TableCell key={plan}>
                                    {planFeatures[plan][feature] ? <CheckIcon /> : <MissedIcon />}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
                <caption>{'* Within purchased API Credits quota'}</caption>
            </Table>
        </TableContainer>
    );
};

export default Desktop;
